import React from 'react';
import { Target, Users, ShieldCheck } from 'lucide-react';

export default function Unternehmen() {
  return (
    <div className="min-h-screen py-20 px-4 bg-background">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold text-primary mb-6 text-center">Über ENVISU</h1>
        <p className="text-lg text-slate-600 text-center max-w-3xl mx-auto mb-16 leading-relaxed">
          Die ENVISU GmbH ist ein spezialisierter Prüfdienstleister für digitale Qualitätssicherung. 
          Wir unterstützen Unternehmen dabei, ihre digitalen Produkte unter echten Bedingungen zu testen.
        </p>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white p-8 rounded-xl border border-border shadow-sm text-center">
            <div className="w-14 h-14 bg-accent/10 text-accent rounded-lg flex items-center justify-center mx-auto mb-6">
              <ShieldCheck className="w-7 h-7" />
            </div>
            <h3 className="text-xl font-bold text-primary mb-3">Maximale Sicherheit</h3>
            <p className="text-slate-600">Wir decken Schwachstellen auf, bevor Ihre Produkte live gehen und echte Nutzer beeinträchtigen.</p>
          </div>
          
          <div className="bg-white p-8 rounded-xl border border-border shadow-sm text-center">
            <div className="w-14 h-14 bg-accent/10 text-accent rounded-lg flex items-center justify-center mx-auto mb-6">
              <Users className="w-7 h-7" />
            </div>
            <h3 className="text-xl font-bold text-primary mb-3">Echte Nutzer</h3>
            <p className="text-slate-600">Keine automatisierten Bots, sondern ein Netzwerk aus echten Menschen aus Ihrer Zielgruppe.</p>
          </div>

          <div className="bg-white p-8 rounded-xl border border-border shadow-sm text-center">
            <div className="w-14 h-14 bg-accent/10 text-accent rounded-lg flex items-center justify-center mx-auto mb-6">
              <Target className="w-7 h-7" />
            </div>
            <h3 className="text-xl font-bold text-primary mb-3">Präzise Analysen</h3>
            <p className="text-slate-600">Detaillierte Fehlerberichte und UX-Feedback helfen Ihnen bei der gezielten Optimierung.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
